export default __webpack_public_path__ + "static/media/edit.4a289030.svg";